/** €1.95 — always two decimals, dot separator (matches the design). */
export function formatEuro(value, digits = 2) {
  return `€${Number(value).toFixed(digits)}`;
}

/** "just now", "5m ago", "2h ago", "3d ago", or a date for anything older than a month. */
export function timeAgo(isoDate, now = Date.now()) {
  const time = new Date(isoDate).getTime();
  if (Number.isNaN(time)) return '—';
  const seconds = Math.max(0, Math.round((now - time) / 1000));
  if (seconds < 60) return 'just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(time).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateTime(isoDate) {
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' });
}

/** "admin@pompi.nl" → "ad***@pompi.nl"; short local parts keep one letter ("a***@x.nl"). */
export function maskEmail(email) {
  const [local = '', domain = ''] = String(email ?? '').trim().split('@');
  if (!local || !domain) return String(email ?? '');
  const visible = local.length > 2 ? local.slice(0, 2) : local.slice(0, 1);
  return `${visible}***@${domain}`;
}

/** 45 → "0:45", 600 → "10:00". */
export function formatCountdown(seconds) {
  const s = Math.max(0, Math.ceil(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}
